<template>
  <div class="storepurchase_Wrapper">
    <!-- 打印条形码 -->
		<el-dialog :title="$t('processed.Barcodeprinting')" :visible.sync="barCodeTrue">
			<el-table border  ref="multipleTable" :data="printDetail" height="450px" select-all="checkedall" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="50">
				</el-table-column> -->
				<el-table-column label="img" :show-overflow-tooltip="true">
					<template slot-scope="images">
						<el-popover placement="top-start" title="" trigger="hover">
							<img :src='images.row.image' alt="" style="width: 150px;height: 150px">
							<img slot="reference" :src='images.row.image' style="width: 30px;height: 30px">
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column property="cusCode" :label="$t('sellerpurchase').cusCode"  :show-overflow-tooltip="true"></el-table-column>
				<el-table-column property="variantName" label="sku"  :show-overflow-tooltip="true"></el-table-column>
				
				<el-table-column property="print_num" :label="$t('sellerpurchase').Purchase_quantity"  :show-overflow-tooltip="true"></el-table-column>
				<el-table-column  :label="$t('processed.printingquantity')" width="200" >
					<template slot-scope="scope">
						<el-input-number size="mini" style="width: 120px;"   :min="1"  v-model="scope.row.variantNum" ></el-input-number>
					</template>
				</el-table-column>
        <el-table-column  :label="$t('other.a33')" show-overflow-tooltip >
					<template slot-scope="scope">
            <el-button size="mini" type="info" @click="delItem(scope.row,scope.$index)">{{$t('other.a273')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="getBarCode()">{{$t('other.a2719')}}</el-button>
      </span>
		</el-dialog>
    <el-dialog
    :title="$t('storeManagement.onvkg')"
    :visible.sync="dialogVisibleTwo"
    width="30%"
    >
    <div>
        <el-select v-model="value4" :placeholder="$t('storeManagement.hginvlg')">
          <el-option
            v-for="item in sellerList.slice(1)"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisibleTwo = false">{{$t('storeManagement.cancel')}}</el-button>
      <el-button type="primary" @click="inventory()" >{{$t('storeManagement.yriunv')}}</el-button>
    </span>
  </el-dialog>
    <el-dialog
    :title="$t('storeManagement.gnivn')"
    :visible.sync="dialogVisible"
    width="60%"
    >
    <div>
      {{$t('storeManagement.gnivn')}}：
      <el-select v-model="TransformSellerId" @change="subMit()" :placeholder="$t('storeManagement.hginvlg')">
        <el-option
          v-for="item in sellerList.slice(1)"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <i class="el-icon-sort vghkjfn"></i>
      <el-select v-model="storeType" @change="getStoreType()" :placeholder="$t('storeManagement.ggru')">
        <el-option
          v-for="item in storeTypeOption"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>

      <el-select style="margin:0 15px" v-model="targetStoreId"  :placeholder="$t('storeManagement.ggru')">
        <el-option
          v-for="item in storeOpton"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>

    <div style="margin-top:20px">
      <el-table
          :data="tableData"
          size="mini"
          border
          style="width: 100%">
          <el-table-column
            prop="store_num"
            :label="$t('storeManagement.yhgnmv')"
           >
          </el-table-column>
          <el-table-column
            prop="volume"
            :label="$t('storeManagement.okmv')"
           >
          </el-table-column>
          <el-table-column
            prop="weight"
            :label="$t('storeManagement.hvkfb')">
          </el-table-column>
           <el-table-column
            prop="audited_stock"
            :label="$t('storeManagement.rjbjh')">
          </el-table-column>
           <el-table-column
            prop="unshipped"
            :label="$t('storeManagement.trbv')">
          </el-table-column>
        </el-table>
    </div>
   
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('storeManagement.cancel')}}</el-button>
      <el-button type="primary" @click="trahnsformStore()">{{$t('storeManagement.ggdfj')}}</el-button>
    </span>
  </el-dialog>
  

<el-dialog
  :title="$t('storeManagement.ivnkf')"
  :visible.sync="diaUpdateStoreNum"
  width="30%"
  >
  <div style="margin-bottom:20px">{{$t('storeManagement.ivnkf')}}：<el-input-number size="small" v-model="updataStoreNum.storeNum"  ></el-input-number></div>
  <div>
    <el-input
    type="textarea"
    :rows="2"
    :placeholder="$t('storeManagement.ikgkvj')"
    v-model="updataStoreNum.msg">
  </el-input>
</div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="diaUpdateStoreNum = false">{{$t('storeManagement.cancel')}}</el-button>
    <el-button type="primary" @click="submitUpdataStoreNum ()">{{$t('storeManagement.yriunv')}}</el-button>
  </span>
</el-dialog>

   <Qrcode-Dialog :instockdia.sync="instockdia" :maincusCode="maincusCode"/>
    <div class="header_top">
      <!-- 一级菜单栏 -->
      <div class="query_list">
        <div style="width: 150px">
          <el-select
            @change="getStoreItemAndGroupCopy()"
            v-model="warehouseId"
            :placeholder="$t('other.a914')"
          >
            <el-option
              v-for="item in warehouseOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div style="width: 150px;margin: 0 5px">
          <el-select @change="getStoreItemAndGroupCopy()"  v-model="SelllerValue"  :placeholder="$t('other.a1558')" >
            <el-option
              v-for="item in sellerList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="query-list-bbc create">
          <el-input
            style="width: 320px; margin: 0 5px"
            clearable
            :placeholder="$t('storeManagement.uhjvhjf')"
            v-model="cusCode"
          ></el-input>
          <el-button type="primary" @click="getStoreItemAndGroup()">{{
            $t("userStoreItems").search
          }}</el-button>
        </div>
        <div>
          <el-button
          style="margin-left: 15px"
          type="primary"
          @click="isExtened = !isExtened"
          >{{ isExtened ? $t('storeManagement.plhjkv') : $t('storeManagement.tjbvl') }}</el-button
        >
        </div>

        <!-- <div style="margin-left: 15px">
          <el-tooltip class="item" effect="dark" :content="$t('other.a2737')" placement="bottom-end">
							<el-button  type="primary" @click="goToABC()">{{$t('other.a2738')}}</el-button>
						</el-tooltip>
        </div> -->

        <div style="margin-left: 15px">
							<el-button  type="primary" @click="exportStoreData()">{{$t('storeManagement.oknvk')}}</el-button>
        </div>

         <div style="margin-left: 15px">
							<el-button  type="primary" @click="dialogVisibleTwo=true">{{$t('storeManagement.ivlionr')}}</el-button>
        </div>
        <div style="margin-left: 15px">
							<el-button  type="primary" @click="printBarcode()">{{$t('other.a2720')}}({{orderList.length}})</el-button>
        </div>

        <!-- <div style="margin-left: 15px">
							<el-button  type="primary" @click="createTransfer()">{{$t('other.a2770')}}</el-button>
        </div> -->

        <!-- <div v-if="userPage ? userPage.page3 : false" style="width: 150px;margin: 0 5px"><el-button type="primary" @click="transformStoreItem()">整仓转移库存及对应关系</el-button></div> -->
      </div>
    </div>
    <!-- 产品展示列表 -->
    <div class="goodsArea">
      <div class="my-goods-data">
        <div
          class="list-item"
          v-for="(outeritem, indexOne) in newUserstoreItem"
          :key="indexOne"
        >
          <div style="border-bottom: 1px solid #e0e0e0">
            <div class="outPsku">
              <div class="outPsku_left">
                <span style="color: red; font-size: 18px; margin-left: 15px">
                  {{$t('storeManagement.uymbk')}}</span
                >
                <span
                  style="color: red; font-size: 18px"
                  v-show="!outeritem.checked01"
                  >{{ outeritem.itemSku }}</span
                >
              </div>
              <div class="outPsku_right">
                <el-button
                  style="margin-left:20px;min-width:160px;"
                  type="primary"
                  @click="outeritem.checked02 = !outeritem.checked02"
                  >{{$t('storeManagement.oknhgh')}}</el-button
                >
              </div>
            </div>

            <div class="outDesc">
              <div style="display: flex">
                <div class="goods-pic">
                  <img
                    v-image-preview
                    :src="
                      outeritem.image
                        ? outeritem.image
                        : outeritem.storeItems
                        ? outeritem.storeItems[0].image
                        : ''
                    "
                  />
                  <span class="fixPic" @click="changePic(outeritem.groupId, 0)"
                    >{{$t('other.a2692')}}</span
                  >
                </div>
                <div style="width: 300px; margin-left: 20px">
                  {{
                    outeritem.storeItems
                      ? outeritem.storeItems[0].itemName
                      : " "
                  }}
                </div>
                <div style="width: 180px; margin-left: 20px; text-align: left">
                  <div>
                    {{$t('storeManagement.kfiuhkg')}}{{
                      outeritem.storeItems ? outeritem.storeItems.length : 0
                    }}
                  </div>
                  <div>{{$t('storeManagement.rhukfh')}}{{ outeritem.qytInStore }}</div>
                  <div>{{$t('storeManagement.yttnkv')}}{{ outeritem.userId }}</div>
                </div>
               
              </div>
            </div>
          </div>
          <div
            v-show="!outeritem.checked02"
            class="childrenItem"
            v-for="(item, index) in outeritem.storeItems
              ? outeritem.storeItems
              : []"
            :key="index"
          >
            <div class="goods-title-desc-wrapper">
              <div class="check_And_Img">
                <div style="margin-right:10px;">
                  <el-checkbox @change="pushItem(item)"  v-model="item.choosed"></el-checkbox>
                </div>
                <div style=" width: 40px; height: 40px; margin: 20px 10px 0 0; position: relative; " >
                  <img v-image-preview width="100%" :src="item.image" />
                  
                </div>
                <div class="goods-title-desc-box">
                  <div
                    style="font-size: 16px; padding-bottom: 5px"
                    
                  >
                    {{$t("storeManagement.oplmg") }}{{ item.skuName }}
                  </div>
                  

                  <div
                    style="font-size: 16px; padding-bottom: 5px"
                   
                  >
                    skuName：{{ item.variationName }}
                  </div>
                  
                  <div class="goods-item-a">
                    {{$t("userStoreItems").cusCode }}：{{ item.cusCode }}
                  </div>
                  <div class="goods-item-a"></div>
                </div>
              </div>

              <div class="goods-title-desc">
                <div class="goods-item-a">
                  {{ $t("userStoreItems.Quantitytobeshipped") }}：{{
                    item.auditedStock
                  }}
                </div>
                <div class="goods-item-a">
                  {{ $t("userStoreItems").shipping_stock }}：{{
                    item.unShipped
                  }}
                </div>

                <div class="goods-item-a">
                  <span  >{{$t('userStoreItems').total_stock}}：{{item.storeNum}}</span>
                  <!-- <span  >{{$t('userStoreItems').total_stock}}：<input style="width: 50px;" size="mini" v-model="item.storeNum" /></span> -->
                  <i  style="margin-left: 15px;color: #409EFF;font-size: 16px;cursor: pointer;"   @click="changeStock(outeritem,item,indexOne,index)" class="el-icon-edit " ></i>
                  <!-- <el-button style="margin-left: 15px;" v-show="item.checked_one"  @click="changeStock(outeritem,item,indexOne,index)" size="mini" type="danger">{{$t('other.a145')}}</el-button> -->
                </div>
              </div>
              <div class="goods-title-desc bbp">
                <div class="goods-item-a">
                  <div>{{ $t("storeManagement.ighkv") }}
                    <span></span>
                   
                    <span v-show="!item.checked">  {{ item.packageLength ? item.packageLength : 0 }}</span>
                    <input v-show="item.checked" style="width: 50px;padding:0px" v-model="item.packageLength">
                    ({{$t('other.a1255')}})x
                    <span v-show="!item.checked">  {{ item.packageWidth ? item.packageWidth : 0 }}</span>
                    <input v-show="item.checked" style="width: 50px;padding:0px" v-model="item.packageWidth">
                     
                     ({{$t('other.a1256')}}) x
                    <span v-show="!item.checked">  {{ item.packageHeight ? item.packageHeight : 0 }}</span>
                    <input v-show="item.checked" style="width: 50px;padding:0px" v-model="item.packageHeight">
                    
                    ({{$t('other.a1257')}}) cm
                  </div>
                </div>

                <div class="goods-item-a">
                  <div>
                    {{ $t("userStoreItems.weight") }}：
                    <span v-show="!item.checked"> {{item.weight ? item.weight : 0}}</span>
                    <input v-show="item.checked" style="width: 50px;padding:0px" v-model="item.weight">
                    kg
                  </div>
                 
                </div>
                <div class="goods-item-a">
                  <div>{{ $t("storeManagement.ibvnkf")}}
                     <span v-show="!item.checked"> {{ item.address ? item.address : $t('other.a354') }}</span>
                    <input v-show="item.checked" style="width: 50px;padding:0px" v-model="item.address">
                  </div>
                </div>
                <div class="goods-item-a">
                  <span  v-show="!item.checked_one">{{$t('other.a2721')}}：{{item.times == 0 ? 1 :  item.times}}</span>
                  <span  v-show="item.checked_one">{{$t('other.a2721')}}：<input style="width: 50px;" size="mini" v-model="item.times" /></span>
                  <i  style="margin-left: 15px;color: #409EFF;font-size: 16px;cursor: pointer;" v-show="!item.checked_one "  @click="item.checked_one = true" class="el-icon-edit " ></i>
                  <el-button style="margin-left: 15px;" v-show="item.checked_one"  @click="updateRateFee(item)" size="mini" type="danger">{{$t('other.a145')}}</el-button>
                  <el-button style="margin-left: 15px;" v-show="item.checked_one"  @click="item.checked_one=false" size="mini" type="info">{{$t('other.a146')}}</el-button>
                </div>
              </div>

              <div class="btn-wrapper">
                <!-- <div class="btn-item-desc">
                  <el-button
                    style="min-width: 160px"
                    type="primary"
                    size="medium"
                    @click.stop="massMoveInSingle(item, indexOne, index)"
                    >{{$t('other.a2555')}} (x {{item.parents.length}})</el-button
                  >
                </div> -->
                 <div class="btn-item-desc">
                  <el-button
                    style="min-width: 160px"
                    :type="item.checked ? 'danger' : 'primary'"
                    size="medium"
                    @click="editor(outeritem,item,indexOne,index)"
                   
                    >{{item.checked ? $t('storeManagement.iomnlgn') : $t('storeManagement.fiklnmv')}}</el-button
                  >

                </div>
                <div class="btn-item-desc">
                  <el-button
                    style="min-width: 160px"
                    type="primary"
                    size="medium"
                    @click.stop="viewstoreoperaterecord(item)"
                    >{{$t('storeManagement.ouhkngj')}}</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页器 -->
        <div class="Pager">
          <el-pagination
            @size-change="handleSizeChangeTwo"
            @current-change="handleCurrentChangeTwo"
            :current-page="currentPage"
            :page-sizes="[15, 20, 30, 100]"
            :page-size="15"
            layout="total, sizes, prev, pager, next, jumper"
            :total="itemsCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import userStoreItems from "../../api/moudles/userStoreItems";
import QrcodeDialog from '../../components/dialog/qrcodeDialog.vue'
import utils from '../../utils/utils'
import { mapState, mapActions, mapMutations } from "vuex";
import newOrders from '../../api/moudles/newOrders';

export default {
  data() {
    return {
      storeTypeOption:[{
        label:this.$t('other.a2722'),
        value:0
      },{
        label:this.$t('other.a2723'),
        value:1
      },{
        label:this.$t('other.a1895'),
        value:2
      },{
        label:this.$t('other.a1896'),
        value:3
      },{
        label:this.$t('other.a1897'),
        value:4
      }],
      warehouseId: null,
      value4:null,
      warehouseOption: null,
      TitleDesc: "",
      handleParam: null,
      cusCode: "",
      newUserstoreItem: [],
      offset: 15,
      instockdia:false,
      dialogVisibleTwo:false,
      barCodeTrue:false,
      getDataList: null,
      page: 0,
      checkedAll: false,
      targetList: [],
      isExtened: false,
      diaUpdateStoreNum:false,
      maincusCode:0,
      isEdit: -1,
      SelllerValue:'all',
      sellerList:[],
      dialogTableVisibleTwo: false,
      additionParents: [],
      isShow: false,
      isEditGoods: false,
      multipleSelection: [],
      additionItem: null,
      itemsCount:0,
      currentPage:1,
      page: 0,
      value: null,
      instockdia:false,
      maincusCode:null,
      dialogVisible:false,
      TransformSellerId:null,
      tableData:[],
      storeType:null,
      targetStoreId:null,
      storeOpton:[],
      multipleSelection:[],
      updataStoreNum:{
        storeNum:0,
        msg:null
      },
      targetList:[],
      printDetail:[],
      userPage:JSON.parse(localStorage.getItem('userInfo')).userPage

     
    };
  },
  components: {
    QrcodeDialog,
  },
  computed: {
    ...mapState({
      userId: (state) => state.shopaccess.userInfo.userId,
      userName: (state) => state.shopaccess.userInfo.userName,
    }),

    orderList(){
      let list=[]
      let arr=[]
      list=this.targetList.filter(item => {
        
        if(item.choosed && arr.indexOf(item.cusCode) == -1){
          arr.push(item.cusCode)
          return item
        }
      })
      return list ? list : []
      console.log('list',list);
    },
  },
  watch: {
    
    isExtened() {
      if (this.isExtened) {
        this.newUserstoreItem.forEach((p) => {
          p.checked02 = true;
        });
      } else {
        this.newUserstoreItem.forEach((p) => {
          p.checked02 = false;
        });
      }
    },
    dialogVisible(){
      if(!this.dialogVisible){
        this.TransformSellerId=null,
        this.tableData=[]
        this.storeType=null
        this.targetStoreId=null
       
        this.storeOpton=[]
      }
    },

    diaUpdateStoreNum(){
      if(!this.diaUpdateStoreNum){
        this.updataStoreNum.msg=null
      }
    }
  },

  created() {
    this.warehouseOption = JSON.parse(
      localStorage.getItem("userInfo")
    ).stores.map((p) => {
      return {
        label: p.storeName,
        value: p.storeId,
      };
    });
    this.warehouseId = this.warehouseOption[0].value;

    this.sellerList=JSON.parse(localStorage.getItem('userInfo')).sellers.map(p => {
        return {
          label:p.userName,
          value:p.userId
        }
      })

      this.sellerList.unshift({
        label:this.$t('other.a1571'),
        value:'all'
      })

    this.getStoreItemAndGroup();
    console.log(this.warehouseId);
  },
  methods: {
  

    ...mapActions("userStoreItems", [
      "updateGroup",
      "sellerUpdateStoreItemDetail",
      'getInstockoperaterecore',
      'deleStoreItems',
      'storeUpdateStoreNumAndAddress',
      'updateStoreNumBystore',
      'getInstockoperaterecore'
    ]),

    createTransfer(){
      api
      .createTransferOrder({
        sellerId:this.warehouseId,
        userId:this.userId
      })
      .then(res => {
      if(res.code === 200 ){
      console.log('desc',res.data)
      this.$message.success(this.$t('other.a2725'))
      }else{
      this.$message.warning(res.msg)
      }
      })
    },
    inventory(){
      if(!this.value4){
        this.$message.warning(this.$t('other.a2726'))
        return
      }
      const {href}=this.$router.resolve({
          name:'inventory',
          query:{
            storeId:this.warehouseId,
            sellerId:this.value4
          }
        
        }) 
        window.open(href)
        this.dialogVisibleTwo=false
        this.value4=null
    },

    handleSelectionChange(val) {
			this.multipleSelection = val
			console.log(this.multipleSelection)
			
			},
    delItem(item,index){
      console.log(item,index);
      
      this.targetList[index].choosed=false
      this.printDetail.splice(index,1)
     
    }, 
    pushItem(item){
      console.log(item.choosed);
        this.targetList.push(item)
    }, 

    getBarCode(){
      if(this.printDetail.length==0){
					this.$message.error(this.$t('other.a1541'))
					return
				}
            let arr=this.printDetail.map(p => {
                    return  {
                       items:{
						    content:p.cusCode,
							height:80,
							width:320,
					   },
					   itemSku:p.variantName,
					   num:p.variantNum
                    }
                })
				utils.settUserAtt({
					attribute:JSON.stringify({
						data:JSON.stringify(arr),
						purchaseOrderId:null,
						storeId:null
						
					}),
					userId:this.userId
				})
                console.log(arr)
					let routeData = this.$router.resolve({
					name: "barCode",
					
				});
				window.open(routeData.href, '_blank');
    },

    printBarcode(){
      console.log('printBarcode',this.orderList)
      this.printDetail=this.orderList.map(p => {
        return {
          image:p.image,
          cusCode:p.cusCode,
          variantName:p.skuName,
          variantNum:p.storeNum == 0 ? 1 : p.storeNum,
          print_num:p.storeNum == 0 ? 1 : p.storeNum,

        }
      })
      this.barCodeTrue = true;
		
				// console.log(row)
				// this.printDetail = row.variantList;
				// this.rukuOrder=row
				// this.printDetail.forEach(p => {
				// 	p.print_num=p.variantNum
				// })
				// this.barCodeTrue = true;
		
    },

    exportStoreData(){
					let list=[]
					userStoreItems
					.getStoreItem({
            addition:false,
            component:true,
            cusCode:null,
            offset:10000,
            page:0,
            sellerId:this.getDataList.sellerId,
            storeId:this.getDataList.storeId,
            userId:this.userId
          })
					.then(res => {
						if(res.code === 200) {
							console.log('仓库产品的item',res.data)
							res.data.groups.forEach(p => {
								if(p.storeItems){
									p.storeItems.forEach(i => {
										list.push({
											'用户帐号':i.userId,
											'用户昵称':i.userName,
											'产品名称':i.itemName,
											'仓库编码':i.cusCode,
											'在仓库存':i.storeNum,
											'线上库存':i.stock,
											'仓库Id':i.storeId,
											'仓库母sku':p.itemSku,
											'仓库子sku':i.skuName,
											'待发数量':i.unShipped,
											'长（cm）':i.packageWidth,
											'宽（cm）':i.packageLength,
											'高（cm）':i.packageHeight,
											'重量（kg）':i.weight,
                      '仓位':i.address
										})
									})
								}
							})

							let arr= ['用户帐号','用户昵称','产品名称','仓库编码','在仓库存','线上库存','仓库Id','仓库母sku','仓库子sku','待发数量','长（cm）','宽（cm）','高（cm）','重量（kg）','仓位']
							utils.exPortEXml(list,arr,'warehouseProduct')
							console.log('list',list)
							
						}
					})

					

				},

    goToABC(){
        let storeList=JSON.parse(localStorage.getItem('userInfo')).stores.filter(p => {
        if(p.storeType == 2){
          return p
        }
      })
      console.log(storeList) 
      let router = this.$router.resolve(
        { 
          name: "treemap" ,
        query:{
          storeId:'10100002'
        }
        }
      );
      window.open(router.href, '_blank');
    },

    trahnsformStore(){
      if(!this.TransformSellerId){
        this.$message.warning(this.$t('other.a2726'))
        return
      }

      if(!this.targetStoreId){
        this.$message.warning(this.$t('other.a2727'))
        return
      }
      let params={
        sellerId:this.TransformSellerId,
        storeId:this.warehouseId,
        targetStoreId:this.targetStoreId,
        userId:this.userId
      }

      newOrders
      .transferSellerStoreItem(params)
      .then(res => {
      if(res.code === 200 ){
      console.log('desc',res.data)
      this.$message.success(this.$t('other.a2728'))
      this.dialogVisible=false
      }else{
      this.$message.warning(res.msg)
      }
      })
      console.log('params',params)
    },

    transformStoreItem(){
      this.dialogVisible=true
    },

    subMit(){
      this.tableData=[]
      this.viewStoreStock({
        sellerId:this.TransformSellerId,
        userId:this.userId,
        storeId:this.warehouseId
      })
    },

    getStoreType(){
      newOrders
      .getStoreAllByType({
        type:this.storeType
      })
      .then(res => {
      if(res.code === 200 ){
      console.log('desc',res.data)
      this.storeOpton=res.data.map(p => {
        return {
          label:p.storeName,
          value:p.storeId
        }
      })
      }else{
      this.$message.warning(res.msg)
      }
      })
    },

    viewStoreStock(params){
      newOrders
      .getSellerStoreItemData(params)
      .then(res => {
      if(res.code === 200 ){
      console.log('desc',res.data)
      this.tableData.push(res.data)
      }else{
      this.$message.warning(res.msg)
      }
      })
    },


    viewstoreoperaterecord(item){
				this.instockdia=true
				this.maincusCode=item.cusCode
				let params={
					cusCode:item.cusCode,
					end:utils.CurdateAddoneday(utils.getRecentDays(0)),
					start:utils.getRecentDays(-7),
					offset:50,
					page:0,
					userId:this.userId
				}
				console.log(params)
				this.getInstockoperaterecore(params)
			},


    editor(outeritem,item,indexOne,index){
      console.log(outeritem,item,indexOne,index)
      item.userId=this.userId
      this.newUserstoreItem[indexOne].storeItems[index].checked=!this.newUserstoreItem[indexOne].storeItems[index].checked

      if(!this.newUserstoreItem[indexOne].storeItems[index].checked){
        
        this.storeUpdateStoreNumAndAddress(item)
      }else{
        
      }

    },

    changeStock(outeritem,item,indexOne,index){
      console.log(item)
      this.updataStoreNum.cusCode=item.cusCode
      this.updataStoreNum.storeNum=item.storeNum
      console.log(this.updataStoreNum)
      this.diaUpdateStoreNum=true
      this.targetFixProduct=item
    },

    updateRateFee(item){
      let rate=JSON.parse(JSON.stringify(item.times))
      if(rate < 1){
        this.$message.warning(this.$t('other.a2729')) 
        item.times=1     
        return
      }

      userStoreItems
      .updateStoreRate({
        cusCode:item.cusCode,
        times:Number(item.times),
        userId:this.userId,
        storeId:item.storeId
      })
      .then(res => {
      if(res.code === 200 ){
      console.log('desc',res.data)
      this.$message.success(this.$t('other.a2730'))
      item.checked_one=false
      }else{
      this.$message.warning(res.msg)
      }
      })
    },



    submitUpdataStoreNum(){
      if(!this.updataStoreNum.msg){
        this.$message.warning(this.$t('other.a2731'))
        return
      }

      this.updateStoreNumBystore(this.updataStoreNum).then(res => {
        if(res == 200){
          this.targetFixProduct.storeNum=this.updataStoreNum.storeNum
          this.diaUpdateStoreNum=false
        }
      })

      console.log(this.updataStoreNum)
    },

    getStoreItemAndGroupCopy(){
      this.page=0
      this.currentPage=1
      this.getStoreItemAndGroup()
    },



    getStoreItemAndGroup() {
    this.getDataList = {
      offset: this.offset,
      page: this.page,
      userId: this.userId,
      storeId: this.warehouseId,
      sellerId:this.SelllerValue == 'all'? '' : this.SelllerValue,
      addition: false,
      component: true,
      cusCode: this.cusCode,
     
    },
    this.newUserstoreItem=[]

    //获取页面赠品的数据
    userStoreItems.getStoreItem(this.getDataList).then((res) => {
        if (res.code === 200) {
          console.log("赠品item", res.data);
          this.itemsCount=res.data.count
            
          if(!res.data.groups.length){
            this.newUserstoreItem=[]
            return
          }
          res.data.groups.forEach((p) => {
            p.checked02=false
            p.qytInStore=0
            p.storeItems.forEach((k) => {
              k.choosed=false
              p.qytInStore+=k.storeNum
              k.checked = false;
              k.checked_one = false;
            });
            this.newUserstoreItem.push(p);
          });
        }
      });
    },

    //控制每页显示订单条数
    handleSizeChangeTwo(val) {
      console.log(`每页 ${val} 条`);
      this.offset = parseInt(`${val}`);
      this.handleCurrentChangeTwo();
    },
    //显示当前第几页
    handleCurrentChangeTwo(val) {
      this.currentPage = parseInt(`${val}`);
      this.page =`${val}` == "undefined" ? 0 : (parseInt(`${val}`) - 1) * this.offset;
      this.getStoreItemAndGroup();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.storepurchase_Wrapper {
  margin-top: 70px;

  .Pager{
    position: fixed;
		bottom: 0;
		left: 225px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	
  }

  /deep/ .el-checkbox__inner {
    width: 20px;
    height: 20px;
  }

  /deep/ .el-checkbox__inner::after {
    height: 10px;
    left: 7px;
    width: 4px;
    font-weight: bold;
  }

  .vghkjfn{
    margin:0 20px;
    font-size: 25px;
    transform: rotate(90deg);
    color: #409EFF;
  }

  .header_top {
    position: fixed;
    width: 100%;
    top: 130px;
    background-color: #fff;
    z-index: 9;
    padding: 0 10px;
    border-bottom: 1px solid #eee;

    .query-list-tcp {
      padding: 10px 0 20px 0;
    }
    .query_list {
      padding: 10px 0 20px 0;
      @include flex-start();
    }
  }

  .goodsArea {
    margin-top: 148px;
    margin-bottom: 120px;
  }

  .list-item {
      margin: 0 5px 0 0;
    box-sizing: border-box;
    padding: 8px ;
    margin-bottom: 10px;
    box-shadow:#909399 1px 2px 5px;

    .childrenItem {
      padding: 10px 0 5px 25px;
      border-bottom: 1px solid #eee;

      .goods-title-desc-wrapper {
        @include flex-between();

        .check_And_Img {
          display: flex;
          width: 450px;
        }
      }
    }

    .outPsku {
      @include flex-between();
      align-items: center;
      box-sizing: border-box;
      padding: 3px 0;
      border-bottom: 1px solid #eee;

      .outPsku_left {
        display: flex;
        align-items: center;

        .el-input {
          width: 300px;
        }

        .el-icon-edit {
          margin-left: 15px;
          cursor: pointer;
          color: #409eff;
          font-size: 18px;
        }
      }

      .outPsku_right {
        display: flex;
        align-items: center;
      }
    }

    .btn-item-desc {
      padding: 0 0 8px 0;
    }

    .outDesc {
      @include flex-between();
      box-sizing: border-box;
      padding: 10px 0;

      .goods-pic {
        width: 60px;
        height: 60px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>